import * as types from './types'
import storage from '@/Plugins/storage'

export default () => ({
  recipients: [],
  defaultCannedMessage: {
    id: null,
    user_id: null,
    organization_id: null,
    subject: '',
    body: '',
    type: '',
    isInactive: false,
    isInvite: false,
  },
  cannedmessage: null,
  cannedmessages: [],
  message: null,
  messages: [],
  mergeTags: [],
})
